// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QbWM","question":"styles_question__2ipLs","inputVisibleButton":"styles_inputVisibleButton__1DPgy","note":"styles_note__11Oie"};